import { render, staticRenderFns } from "./AdminNeedResponse.vue?vue&type=template&id=0696aa71&scoped=true&"
import script from "./AdminNeedResponse.vue?vue&type=script&lang=js&"
export * from "./AdminNeedResponse.vue?vue&type=script&lang=js&"
import style0 from "./AdminNeedResponse.vue?vue&type=style&index=0&id=0696aa71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696aa71",
  null
  
)

export default component.exports